import React from "react";
import * as Icons from "lucide-react";

export const StatCard = ({ icon, label, value, accent = "gold", testid }) => {
  const C = Icons[icon] || Icons.Circle;
  const color = accent === "green" ? "text-approval bg-approval/12 border-approval/25" : "text-gold bg-gold/12 border-gold/25";
  return (
    <div className="card-dark rounded-2xl p-5" data-testid={testid}>
      <div className={`w-10 h-10 rounded-xl border flex items-center justify-center mb-3 ${color}`}>
        <C className="w-5 h-5" />
      </div>
      <div className="font-mono-fin text-2xl font-extrabold text-white">{value}</div>
      <div className="text-sm text-slate-400 mt-0.5">{label}</div>
    </div>
  );
};

export const StatusBadge = ({ status }) => {
  const map = {
    New: "bg-blue-500/15 text-blue-400",
    "In Process": "bg-amber-500/15 text-amber-400",
    Approved: "bg-approval/15 text-approval",
    Disbursed: "bg-approval/20 text-approval",
    Rejected: "bg-red-500/15 text-red-400",
    pending: "bg-amber-500/15 text-amber-400",
    approved: "bg-approval/15 text-approval",
    paid: "bg-approval/20 text-approval",
  };
  return (
    <span className={`text-xs font-semibold px-2.5 py-1 rounded-full capitalize ${map[status] || "bg-white/10 text-slate-300"}`}>
      {status}
    </span>
  );
};

export const money = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");
